import React, { useMemo } from "react";

import { RedZoneErrorType, CountyBlockerErrorType } from "@covertree/types";
import { Box, Stack, Typography } from "@mui/material";

import { Button, LegalDisclaimer } from "@covertree/ui";
import { ERROR_MESSAGE } from "@covertree/consts";

interface Props {
  errorType: RedZoneErrorType | CountyBlockerErrorType;
  errorMessage?: string;
  icon: string;
  onCreateNewQuote?(): void;
  showLegalText?: boolean;
}

export function FastUWRejection({
  errorType,
  errorMessage,
  icon,
  onCreateNewQuote,
  showLegalText = false,
}: Props) {
  const errorHeader = useMemo(() => {
    switch (errorType) {
      case RedZoneErrorType.ActiveFireError:
        return ERROR_MESSAGE.ACTIVE_FIRE_DANGER;
      case RedZoneErrorType.ExcessiveRiskError:
        return ERROR_MESSAGE.HIGH_RISK_FIRE_DANGER;
      case CountyBlockerErrorType.BlockedCountyError:
        return errorMessage;
    }
  }, [errorType]);

  return (
    <Stack direction="column" spacing={6}>
      <Stack direction="column" spacing={1}>
        <Box
          component="img"
          src={icon}
          alt="decline property"
          sx={(theme) => ({
            maxWidth: theme.spacing(20),
          })}
        />
        <Typography variant="h3">{errorHeader}</Typography>
      </Stack>
      {!!onCreateNewQuote && (
        <Button onClick={onCreateNewQuote}>Create New Quote</Button>
      )}
      {showLegalText && (
        <LegalDisclaimer variant="subtitle1">
          CoverTree Inc. &#40;CoverTree&#41; is acting as the managing general
          agent of one or more non-affiliated underwriters in selling this
          insurance policy.
        </LegalDisclaimer>
      )}
    </Stack>
  );
}
